import * as React from 'react'

interface Props {
  style?: React.CSSProperties
}

export const ImagePlaceholder = (props: Props) => {
  return (
    <i
      className='image-placeholder rounded fa fa-picture-o d-flex align-items-center justify-content-center text-white'
      style={{
        backgroundColor: 'lightgrey',
        fontSize: '2rem',
        ...props.style,
      }}
    />
  )
}
